import { useEffect, useState } from "react";

// Keeps the screen awake while `active` (re-acquired when the tab becomes visible again).
export function useWakeLock(active) {
  const [status, setStatus] = useState("off");
  useEffect(() => {
    if (!active) { setStatus("off"); return; }
    if (!("wakeLock" in navigator)) { setStatus("unsupported"); return; }
    let lock = null;
    let cancelled = false;
    const acquire = async () => {
      if (document.visibilityState !== "visible" || (lock && !lock.released)) return;
      try {
        lock = await navigator.wakeLock.request("screen");
        if (cancelled) return lock.release();
        setStatus("on");
        lock.addEventListener("release", () => !cancelled && setStatus("released"));
      } catch { setStatus("unsupported"); }
    };
    acquire();
    document.addEventListener("visibilitychange", acquire);
    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", acquire);
      lock?.release().catch(() => {});
    };
  }, [active]);
  return status;
}
